import axios from 'axios'

const service = {
  addStat (body) {
    if (process.env.VUE_APP_ENV === 'production') {

      const src = localStorage.getItem('statsSRC')
      body.SRC = src && src.length > 0 ? src : null
      console.log('src', src)

      axios.post(`https://cm-dtouch-stats-api.dtouch.es/v1/public/stats/t/stats`, body)
        .then(response => response)
        .catch((error) => {
          console.log(error)
        })
    }
    /*
    let url = process.env.VUE_APP_ENV === 'development' ? 'http://dtouch.local:3805' : 'https://dtouch-stats-api.dtouch.es'
    return axios.post(`${url}/v1/public/stats/stats`, body)
      .then(response => response
      )
      .catch((error) => {
        console.log(error)
      })
    */
  },
  getStatsByWorkspaceID (workspaceID) {
    let url = process.env.VUE_APP_ENV === 'development' ? 'http://dtouch.local:3805' : 'https://dtouch-stats-api.dtouch.es'
    return axios.get(`${url}/v1/public/stats/${workspaceID}/stats`)
      .then(response => response
      )
      .catch((error) => {
        console.log(error)
      })
  },
  getStatsByWorkspaceIDByFilter (workspaceID, filter) {
    let url = process.env.VUE_APP_ENV === 'development' ? 'http://dtouch.local:3805' : 'https://dtouch-stats-api.dtouch.es'
    return axios.get(`${url}/v1/public/stats/${workspaceID}/stats?year=${filter.year}&month=${filter.month}`)
      .then(response => response
      )
      .catch((error) => {
        console.log(error)
      })
  }
}

export default service

